<template>
  <div>
    <van-loading type="spinner" v-if="nodata"/>
    <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#004FFF"></topIcon>
    <div style="background: #A80034;">
            <div class="logo lefts" v-if="dominItem.templateId === 'temp1'">
              <span>{{ dominItem.logoName || 'Logo' }}</span>
                <div class="category" >
                  <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                      item.label
                    }}</span>
                </div>
            </div>

      <div class="logo rights" v-if="dominItem.templateId === 'temp2' || dominItem.templateId === 'temp3'">
        <span>{{ dominItem.logoName || 'Logo' }}</span>
        <div class="category" >
                  <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                      item.label
                    }}</span>
        </div>
      </div>
    </div>

    <div>
      <div class="news-page">
        <div class="beauty-tech-container">
          <!-- 顶部广告横幅 -->
          <div class="top-banner" @click="toDetail(bestItem.articleShortName)">
            <img
                :src="bestItem.articleImage"
                class="banner-image"
            />
            <div class="banner-content">
              <h3>{{ bestItem.articleTitle }}</h3>
            </div>
          </div>
          <div class="content-wrapper">
            <!-- 左侧主要新闻区域 -->
            <div class="main-content">
              <div style="display: flex; align-items: center; font-size: 20px; font-weight: bold; margin-bottom: 20px">
                <div class="kuais"></div>
                {{ $t('con_hot_con') }}
              </div>
              <!-- 新闻条目 -->
              <div class="news-articles aaa">
                <!-- 新闻条目1 -->
                <div class="news-article" style="flex-direction: column" v-for="item in articleList1"
                     @click="toDetail(item.articleShortName)">
                  <img
                      style="width: 100%"
                      :src="item.articleImage"
                      class="article-image"
                  />
                  <div>

                    <div class="article-header">
                      <h2 class="twoHde" style="margin-left: 0; margin-top: 10px">{{ item.articleTitle }}</h2>
                    </div>

                    <div class="article-excerpt twoHde" style="margin-left: 0">
                      {{item.articleIntro}}
                    </div>
<!--                    <div class="article-meta">-->
<!--                      <span class="article-date">{{ item.uploadTime }}</span>-->
<!--                    </div>-->
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- 主要内容区域 -->
          <div class="content-wrapper">
            <!-- 左侧主要新闻区域 -->
            <div class="main-content">
              <div style="display: flex; align-items: center; font-size: 20px; font-weight: bold; margin-bottom: 20px">
                <div class="kuais"></div>
                {{ $t('con_latest') }}
              </div>
              <!-- 新闻条目 -->
              <div class="news-articles">
                <!-- 新闻条目1 -->
                <div class="news-article" v-for="item in articleList2" @click="toDetail(item.articleShortName)">
                  <img
                      :src="item.articleImage"
                      alt="相关图片1"
                      class="article-image"
                  />
                  <div>

                    <div class="article-header">
                      <h2 class="twoHde" style="margin-left: 0">{{item.articleTitle}}</h2>
                    </div>
<!--                    <div class="article-meta">-->
<!--                      <span class="article-date">{{ item.uploadTime }}</span>-->
<!--                    </div>-->
                    <div class="article-excerpt twoHde" style="margin-left: 0">
                      {{item.articleIntro}}
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- 右侧边栏 -->
            <div class="sidebar">
              <!-- 7*24快讯 -->
              <div class="news-flash">
                <div class="flash-header">
                  <h3>{{ $t('con_bestnew') }}</h3>
                </div>
                <div class="flash-list">
                  <div class="flash-item" v-for="item in articleList" @click="toDetail(item.articleShortName)">
                    <div class="flash-dot"></div>
                    <div class="flash-content">
<!--                      <div class="flash-time">{{ item.uploadTime }}</div>-->
                      <div class="flash-title twoHde" style="margin-left: 0" >{{ item.articleTitle }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="but-box">
      </div>
    </div>
    <div class="buttom">
      <div class="kuai">
        <div class="btn-logo">{{ dominItem.logoName || 'Logo' }}
          <div style="display: flex; align-items: center">
            <img class="imgsss" v-if="dominItem.nationId !== 'cn'" v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url" alt="">
          </div>
        </div>
        <div class="explore">
          <span v-for="item in typeList" @click="changeType(item.id)"
                style="cursor: pointer; color: #ffffff">{{ item.label }}</span>
        </div>
        <footers is00="is04" color="#ffffff" widd="none" style="border-top: 1px solid #fff"
                 :articleListlast="articleListlast" :current="current"></footers>
      </div>
    </div>
  </div>
</template>

<script>
import {getOne, newContent} from "@/api"
import topIcon from '../../icons/small.vue'
import {format} from "date-fns";
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList: [],
      latestNewsList: [],
      articleList: [],
      articleList1: [],
      articleList2: [],
      articleList3: [],
      articleList4: [],
      articleListlast: [],
      recommendList1: [],
      typeList: [
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_home'), id: 1},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_LIFESTYLE'), id: 5},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    } else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取推荐文章列表
    getArticleList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 23,
        articleNationId: this.nationId,
        articleType: 'con_recommended'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },


    // 获取最新文章
    getLatestNewsList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_latest'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取热门文章
    getRecommendList() {
      newContent({
        articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 10,

        articleNationId: this.nationId, articleType: 'con_hot_con'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList2 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList1() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 12,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList3 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList2() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 12,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList4 = res.rows
      })
    },

    // 获取最下面文章列表  相关文章
    getArticleListlast() {
      // this.nodata = true
      newContent({
        articleCategoryId: this.current,
        pageNum: 3,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_related'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.news-page {
  width: 60%;
  margin: auto;

  .beauty-tech-container {
    padding: 20px 0px;
    min-height: 100vh;
  }

  // 顶部广告横幅
  .top-banner {
    position: relative;
    margin-bottom: 20px;
    border-radius: 4px;
    overflow: hidden;

    .banner-image {
      width: 100%;
      height: 500px;
      object-fit: cover;
    }

    .banner-content {
      position: absolute;
      top: 90%;
      left: 20px;
      transform: translateY(-50%);
      color: #fff;

      h3 {
        font-size: 20px;
        font-weight: bold;
        margin: 0;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
      }
    }
  }

  // 内容包装器
  .content-wrapper {
    display: flex;
    gap: 20px;
  }

  .kuais {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    background: #004FFF;
  }

  // 主要内容区域
  .main-content {
    flex: 1;

    .content-tabs {
      display: flex;
      margin-bottom: 20px;

      .tab-item {
        padding: 8px 16px;
        margin-right: 10px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;

        &.new {
          background-color: #e6f7ff;
          color: #1890ff;

          &.active {
            background-color: #1890ff;
            color: #fff;
          }
        }

        &.recommended {
          background-color: #f6ffed;
          color: #52c41a;

          &.active {
            background-color: #52c41a;
            color: #fff;
          }
        }

        &.hot {
          background-color: #fff2f0;
          color: #ff4d4f;

          &.active {
            background-color: #ff4d4f;
            color: #fff;
          }
        }
      }
    }

    .news-articles {
      .news-article {
        background-color: #fff;
        align-items: center;
        padding: 10px;
        display: flex;
        margin-bottom: 20px;
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

        .article-header {
          margin-bottom: 10px;

          h2 {
            font-size: 18px;
            color: #333;
            margin: 0;
            line-height: 1.5;
          }
        }

        .article-meta {
          margin-bottom: 10px;

          .article-date {
            color: #999;
            font-size: 14px;
          }
        }

        .article-excerpt {
          color: #666;
          font-size: 14px;
          line-height: 1.6;
        }

        .article-footer {
          display: flex;
          gap: 15px;
          margin-bottom: 15px;

          .article-time,
          .article-source,
          .article-comments {
            color: #999;
            font-size: 14px;
          }
        }

        .article-images {
          display: flex;
          gap: 10px;


        }

        .article-banner {
          position: relative;
          margin-bottom: 15px;
          border-radius: 4px;
          overflow: hidden;

          .banner-image-large {
            width: 100%;
            height: 200px;
            object-fit: cover;
          }

          .banner-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 15px;
            background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
            color: #fff;

            .banner-date {
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 5px;
            }

            .banner-title {
              font-size: 14px;
            }
          }
        }
      }
    }

    .aaa {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 20px;
    }
  }

  // 侧边栏
  .sidebar {
    width: 300px;

    .sidebar-ad {
      position: relative;
      margin-bottom: 20px;
      border-radius: 4px;
      overflow: hidden;

      .ad-image {
        width: 100%;
        height: 150px;
        object-fit: cover;
      }

      .ad-label {
        position: absolute;
        top: 10px;
        right: 10px;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
      }

      .ad-text {
        padding: 10px;
        text-align: center;
        color: #333;
        font-size: 14px;
        background-color: #fff;
      }
    }

    .news-flash {
      background-color: #fff;
      padding: 15px;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

      .flash-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        h3 {
          font-size: 16px;
          color: #333;
          margin: 0;
          font-weight: bold;
        }

        .more-link {
          color: #999;
          font-size: 14px;
          text-decoration: none;

          &:hover {
            color: #1890ff;
          }
        }
      }

      .flash-list {
        .flash-item {
          display: flex;
          margin-bottom: 15px;
          align-items: flex-start;

          .flash-dot {
            width: 8px;
            height: 8px;
            background-color: #1890ff;
            border-radius: 50%;
            margin-right: 10px;
            margin-top: 6px;
            flex-shrink: 0;
          }

          .flash-content {
            flex: 1;

            .flash-time {
              color: #999;
              font-size: 12px;
              margin-bottom: 4px;
            }

            .flash-title {
              color: #333;
              font-size: 14px;
              line-height: 1.5;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    .content-wrapper {
      flex-direction: column;
    }
    .sidebar {
      width: 100%;
    }
    .article-images {
      flex-direction: column;
    }
  }
}


.article-image {
  width: 150px;
  height: 150px !important;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 10px;
}
.but-box {

}


.logo {
  position: fixed;
  padding: 10px 20px;
  top: 100px;
  background: #ffffff;
  //left: calc(20% - 200px);
  margin: 0 auto;
  display: flex;
  border-radius: 10px;
  flex-direction: column;
  box-sizing: border-box;
  font-size: 17px;
  color: #333333;

  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.lefts{
  left: calc(20% - 230px);
}

.rights {
  right: calc(20% - 230px);
}

.logo-temp1 {
  padding: 0 20px 0 10%;
}

.logo-temp2 {
}

.category {
  min-height: 40px;
  //margin-bottom: 30px;
  color: #000000;
  margin-top: 50px;
  font-weight: 700;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid #E6E8EA;
  line-height: 38px;
  display: flex;
  flex-direction: column;

  span {
    text-align: center;
    font-weight: 500;
    font-size: 15px;
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
    //border-bottom: 3px solid #ffffff;
  }

  span:hover {
    color: #ffffff;
    //border-bottom: 3px solid #013497;
    transition: all .1s ease;
    background: #004FFF;
    border-radius: 5px;
    //border-bottom: 3px solid #E2001A;
  }

  .choose {
    transition: all .1s ease;
    color: #ffffff;
    border-radius: 5px;
    background: #004FFF;
    //border-bottom: 3px solid #013497;
  }
}

.buttom {
  background: #2C3137;
  display: flex;
  padding-top: 30px;
  flex-direction: column;

  .kuai {
    //width: 1260px;
    padding: 0 calc(10% - 20px) 0 calc(10% - 40px);
    margin: auto;
  }

  .btn-logo {
    margin-left: 50px;
    font-size: 40px;
    color: #ffffff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent;
  }

  .explore {
    display: flex;
    margin-left: 50px;
    margin-top: 30px;
    margin-bottom: 20px;
    justify-content: center;
    align-items: center;
    font-weight: bold;

    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(3) {
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

.bgSpan {
  color: #ffffff;
  border-radius: 5px;
  border: 1px solid red;
  display: inline-block;
  padding: 5px 10px;
  background: #E2001A;
}
.arabic-layout {
  .logo {
    flex-direction: column !important;
  }

  .category {
    flex-direction: column !important;
  }

}
</style>